/**
 * Project : workspace
 * File    : BusinessMenuConfig.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package common.constants

import androidx.compose.ui.graphics.Color
import com.parmartechnologies.app.composeapp.generated.resources.Res
import com.parmartechnologies.app.composeapp.generated.resources.business_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.catalogue_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.customer_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.employee_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.invoice_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.orders_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.product_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.sale_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.store_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.sub_category_menu_icon
import com.parmartechnologies.business.feature.business.handler.BusinessHandler
import com.parmartechnologies.business.feature.businessMenu.modal.BusinessMenu
import com.parmartechnologies.business.feature.businessMenu.modal.MenuType
import com.parmartechnologies.core.feature.locale.Localization
import navigation.route.business.BusinessNavRoute
import navigation.route.customer.CustomerNavRoute
import navigation.route.inventory.InventoryNavRoute
import navigation.route.inventory.product.ProductNavRoute
import navigation.route.invoice.InvoiceNavRoute
import navigation.route.order.OrderNavRoute
import navigation.route.relation.RelationNavRoute
import navigation.route.sale.SaleNavRoute
import navigation.route.workforce.EmployeeNavRoute


/**
 * Represents the business menu config class.
 */


class BusinessMenuConfig {
    fun getPointOfSaleMenu(localization: Localization?): List<BusinessMenu> {
        val firstMenu: ArrayList<BusinessMenu> = arrayListOf()
        firstMenu.add(
            BusinessMenu(
                "sale",
                MenuType.MENU,
                localization?.businessMenu?.menuLabelSale,
                Res.drawable.sale_menu_icon,
                SaleNavRoute.LIST,
                Color(0xFFF5F5D5)
            )
        )
        firstMenu.add(
            BusinessMenu(
                "invoice",
                MenuType.MENU,
                localization?.businessMenu?.invoice,
                //"Invoice",
                Res.drawable.invoice_menu_icon,
                InvoiceNavRoute.LIST,
                Color(0xFFE3F5E2)
            )
        )
        val allMenuItems = listOf(
            BusinessMenu(
                "sale_header",
                MenuType.HEADER,
                localization?.businessMenu?.sale,
                Res.drawable.store_menu_icon,
                SaleNavRoute.HOME,
                Color(0xFFF5F5D5)
            ),
            BusinessMenu(
                "sale",
                MenuType.MENU,
                "",
                Res.drawable.sale_menu_icon,
                SaleNavRoute.HOME,
                Color(0xFFffffff),
                firstMenu
            ),
        )
        return allMenuItems
    }
    /**
 * Executes the get online sale menu operation.
 *
 * @receiver TODO
 * @param localization The localization.
 * @return The resulting list< business menu>.
 */
    fun getOnlineSaleMenu(localization: Localization?): List<BusinessMenu> {
        val thirdMenu: ArrayList<BusinessMenu> = arrayListOf()
        if (!BusinessHandler.shared().repository.myBusiness.value.Name.isNullOrEmpty()) {
            thirdMenu.add(
                BusinessMenu(
                    "business",
                    MenuType.MENU,
                    BusinessHandler.shared().repository.myBusiness.value.Name,
                    Res.drawable.business_menu_icon,
                    BusinessNavRoute.DETAILS,
                    Color(0xFFF5F5D5)
                )
            )
        }
        thirdMenu.add(
            BusinessMenu(
                "business",
                MenuType.MENU,
                localization?.businessMenu?.storeLabel,
                //"Store",
                Res.drawable.business_menu_icon,
                BusinessNavRoute.STORE,
                Color(0xFFBCDBFF)
            )
        )
        return thirdMenu
    }
    /**
 * Executes the get inventory menu operation.
 *
 * @receiver TODO
 * @param localization The localization.
 * @return The resulting list< business menu>.
 */
    fun getInventoryMenu(localization: Localization?): List<BusinessMenu> {
        val secondMenu: ArrayList<BusinessMenu> = arrayListOf()
        secondMenu.add(
            BusinessMenu(
                "product",
                MenuType.MENU,
                localization?.businessMenu?.product,
                //"product",
                Res.drawable.product_menu_icon,
                ProductNavRoute.LIST,
                Color(0xFFDEF4F8)
            )
        )
        secondMenu.add(
            BusinessMenu(
                "category",
                MenuType.MENU,
                localization?.businessMenu?.category, // "Category",
                Res.drawable.catalogue_menu_icon,
                InventoryNavRoute.ProductCategory.LIST,
                Color(0xFFE7E7E7)
            )
        )
        secondMenu.add(
            BusinessMenu(
                "sub_category",
                MenuType.MENU,
                localization?.businessMenu?.subCategory,
                //"Sub Category",
                Res.drawable.sub_category_menu_icon,
                InventoryNavRoute.ProductSubCategory.LIST,
                Color(0xFFF9E0F5)
            )
        )
        secondMenu.add(
            BusinessMenu(
                "stock",
                MenuType.MENU,
                localization?.businessMenu?.stock,
                //"Stock",
                Res.drawable.invoice_menu_icon,
                InventoryNavRoute.PRODUCTS,
                Color(0xFFFEF7F3)
            )
        )
        val allMenuItems = listOf(

            BusinessMenu(
                "inventory_header",
                MenuType.HEADER,
                localization?.businessMenu?.inventory,
                Res.drawable.store_menu_icon,
                InventoryNavRoute.LIST,
                Color(0xFFDEF4F8)
            ),
            BusinessMenu(
                "inventory",
                MenuType.MENU,
                "",
                Res.drawable.store_menu_icon,
                InventoryNavRoute.Product.LIST,
                Color(0xFFffffff),
                secondMenu
            ),
        )
        return allMenuItems
    }
    /**
 * Executes the get relations menu operation.
 *
 * @receiver TODO
 * @param localization The localization.
 * @return The resulting list< business menu>.
 */
    fun getRelationsMenu(localization: Localization?): List<BusinessMenu> {
        val menus: ArrayList<BusinessMenu> = arrayListOf()
        menus.add(
            BusinessMenu(
                "employee",
                MenuType.MENU,
                localization?.businessMenu?.employee,
                //"Employee",
                Res.drawable.employee_menu_icon,
                EmployeeNavRoute.LIST,
                Color(0xFFFFF3E0)
            )
        )
        menus.add(
            BusinessMenu(
                "customer",
                MenuType.MENU,
                localization?.businessMenu?.customer,
                //"Customer",
                Res.drawable.customer_menu_icon,
                CustomerNavRoute.LIST,
                Color(0xFFFDE0DD)
            )
        )
        menus.add(
            BusinessMenu(
                RelationNavRoute.LIST,
                MenuType.HEADER,
                "Connection",
                Res.drawable.business_menu_icon,
                RelationNavRoute.LIST,
                Color(0xFFBCDBFF)
            )
        )
        val allMenuItems = listOf(
            BusinessMenu(
                "store_header",
                MenuType.HEADER,
                localization?.businessMenu?.sale,
                Res.drawable.store_menu_icon,
                InventoryNavRoute.Product.LIST,
                Color(0xFFDEF4F8)
            ),
            BusinessMenu(
                "connection",
                MenuType.MENU,
                "Connection",
                Res.drawable.store_menu_icon,
                BusinessNavRoute.STORE,
                Color(0xFFffffff),
                menus
            )
        )
        return allMenuItems
    }
    /**
 * Executes the get menu operation.
 *
 * @receiver TODO
 * @param localization The localization.
 * @return The resulting list< business menu>.
 */
    fun getMenu(localization: Localization?): List<BusinessMenu> {
        val firstMenu: ArrayList<BusinessMenu> = arrayListOf()
        firstMenu.add(
            BusinessMenu(
                "sale",
                MenuType.MENU,
                localization?.businessMenu?.menuLabelSale,
                Res.drawable.sale_menu_icon,
                SaleNavRoute.LIST,
                Color(0xFFF5F5D5)
            )
        )
        firstMenu.add(
            BusinessMenu(
                "invoice",
                MenuType.MENU,
                localization?.businessMenu?.invoice,
                //"Invoice",
                Res.drawable.invoice_menu_icon,
                InvoiceNavRoute.LIST,
                Color(0xFFE3F5E2)
            )
        )

        val secondMenu: ArrayList<BusinessMenu> = arrayListOf()
        secondMenu.add(
            BusinessMenu(
                "product",
                MenuType.MENU,
                localization?.businessMenu?.product,
                //"product",
                Res.drawable.product_menu_icon,
                ProductNavRoute.LIST,
                Color(0xFFDEF4F8)
            )
        )
        secondMenu.add(
            BusinessMenu(
                "category",
                MenuType.MENU,
                localization?.businessMenu?.category, // "Category",
                Res.drawable.catalogue_menu_icon,
                InventoryNavRoute.ProductCategory.LIST,
                Color(0xFFE7E7E7)
            )
        )
        secondMenu.add(
            BusinessMenu(
                "sub_category",
                MenuType.MENU,
                localization?.businessMenu?.subCategory,
                //"Sub Category",
                Res.drawable.sub_category_menu_icon,
                InventoryNavRoute.ProductSubCategory.LIST,
                Color(0xFFF9E0F5)
            )
        )
        secondMenu.add(
            BusinessMenu(
                "stock",
                MenuType.MENU,
                localization?.businessMenu?.stock,
                //"Stock",
                Res.drawable.invoice_menu_icon,
                InventoryNavRoute.LIST,
                Color(0xFFFEF7F3)
            )
        )


        val thirdMenu: ArrayList<BusinessMenu> = arrayListOf()
        if (BusinessHandler.shared().repository.myBusiness.value.Name.isNotEmpty()) {
            thirdMenu.add(
                BusinessMenu(
                    "business",
                    MenuType.MENU,
                    BusinessHandler.shared().repository.myBusiness.value.Name,
                    Res.drawable.business_menu_icon,
                    BusinessNavRoute.DETAILS,
                    Color(0xFFF5F5D5)
                )
            )
        }
        thirdMenu.add(
            BusinessMenu(
                "business",
                MenuType.MENU,
                localization?.businessMenu?.storeLabel,
                //"Store",
                Res.drawable.business_menu_icon,
                BusinessNavRoute.STORE,
                Color(0xFFBCDBFF)
            )
        )
        thirdMenu.add(
            BusinessMenu(
                "employee",
                MenuType.MENU,
                localization?.businessMenu?.employee,
                //"Employee",
                Res.drawable.employee_menu_icon,
                EmployeeNavRoute.LIST,
                Color(0xFFFFF3E0)
            )
        )
        thirdMenu.add(
            BusinessMenu(
                "customer",
                MenuType.MENU,
                localization?.businessMenu?.customer,
                //"Customer",
                Res.drawable.customer_menu_icon,
                CustomerNavRoute.LIST,
                Color(0xFFFDE0DD)
            )
        )
        thirdMenu.add(
            BusinessMenu(
                "all_business",
                MenuType.MENU,
                localization?.businessMenu?.allBusiness,
                //"All Business",
                Res.drawable.business_menu_icon,
                BusinessNavRoute.LIST,
                Color(0xFFE7E7E7)
            )
        )
        thirdMenu.add(
            BusinessMenu(
                "all_business",
                MenuType.MENU,
                "Orders",
                //"All Business",
                Res.drawable.orders_menu_icon,
                OrderNavRoute.LIST,
                Color(0xFFFDE0DD)
            )
        )
        val fourthMenu: ArrayList<BusinessMenu> = arrayListOf()
        fourthMenu.add(
            BusinessMenu(
                BusinessNavRoute.CONNECTION,
                MenuType.HEADER,
                "Connection",
                Res.drawable.business_menu_icon,
                BusinessNavRoute.CONNECTION,
                Color(0xFFBCDBFF)
            )
        )
        val allMenuItems = listOf(
            BusinessMenu(
                "sale_header",
                MenuType.HEADER,
                localization?.businessMenu?.sale,
                Res.drawable.store_menu_icon,
                SaleNavRoute.HOME,
                Color(0xFFF5F5D5)
            ),
            BusinessMenu(
                "sale",
                MenuType.MENU,
                "",
                Res.drawable.sale_menu_icon,
                SaleNavRoute.HOME,
                Color(0xFFffffff),
                firstMenu
            ),
            BusinessMenu(
                "inventory_header",
                MenuType.HEADER,
                "Online Store",
                Res.drawable.store_menu_icon,
                InventoryNavRoute.LIST,
                Color(0xFFDEF4F8)
            ),
            BusinessMenu(
                "inventory",
                MenuType.MENU,
                "",
                Res.drawable.store_menu_icon,
                InventoryNavRoute.Product.LIST,
                Color(0xFFffffff),
                secondMenu
            ),
            BusinessMenu(
                "store_header",
                MenuType.HEADER,
                "Online Store",
                Res.drawable.store_menu_icon,
                InventoryNavRoute.Product.LIST,
                Color(0xFFDEF4F8)
            ),
            BusinessMenu(
                "store",
                MenuType.MENU,
                "",
                Res.drawable.store_menu_icon,
                BusinessNavRoute.STORE,
                Color(0xFFffffff),
                thirdMenu
            ),
            BusinessMenu(
                "connection",
                MenuType.MENU,
                "Connection",
                Res.drawable.store_menu_icon,
                BusinessNavRoute.STORE,
                Color(0xFFffffff),
                fourthMenu
            )
        )
        return allMenuItems
    }
}